import { DashboardModule, Form } from '@domain-group/suit-theme'

import { UseBrandFormPayload } from '@hooks/useBrand'

import ToggleListItem from '@components/ToggleListItem'

import { toggleNestedValue } from '@functions/entity'

interface ComplianceSettingsProps {
  brandFormPayload: UseBrandFormPayload,
}

const ComplianceSettings = (props: ComplianceSettingsProps) => {
  const { brandFormPayload } = props

  const {
    entityState: {
      options,
    },
  } = brandFormPayload

  const {
    aml_compliance_enforcement,
  } = options

  return (
    <DashboardModule title="Compliance Settings">
      <Form padding="large" boxProps={{ paddingBottom: 'medium' }}>
        <ToggleListItem
          onClick={() => (
            toggleNestedValue(brandFormPayload, 'options.aml_compliance_enforcement', { shouldSetState: true })
          )}
          toggleValue={aml_compliance_enforcement}
          toggleOffText="No"
          toggleOnText="Yes"
        >
          <ToggleListItem.Title>AML Compliance Enforcement</ToggleListItem.Title>

          <ToggleListItem.Description>
            Controls whether AML gating is active for all agencies under this brand.
          </ToggleListItem.Description>
        </ToggleListItem>
      </Form>
    </DashboardModule>
  )
}

export default ComplianceSettings
